import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0001 = React.lazy(() => import('./symbols/0001_back_left_arrow'));
const Symbol0002 = React.lazy(() => import('./symbols/0002_highlight'));
const Symbol0003 = React.lazy(() => import('./symbols/0003_pronto'));
const Symbol0004 = React.lazy(() => import('./symbols/0004_provider_code'));
const Symbol0005 = React.lazy(() => import('./symbols/0005_ok_successful_tick'));

export interface IProps {}

const TM3: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0001_back_left_arrow" symbol={<Symbol0001 />} />
      <LazySymbol id="0002_highlight" symbol={<Symbol0002 />} />
      <LazySymbol id="0003_pronto" symbol={<Symbol0003 />} />
      <LazySymbol id="0004_provider_code" symbol={<Symbol0004 />} />
      <LazySymbol id="0005_ok_successful_tick" symbol={<Symbol0005 />} />
    </>
  );
});

TM3.displayName = 'TM3';

export default TM3;
